const transferStatuses = ['pending%20pickup', 'in%20transit'];

export { transferStatuses };



// WEBPACK FOOTER //
// ./src/common/constants/transferStatuses.js